import { render, staticRenderFns } from "./HistoriqueIntegration.vue?vue&type=template&id=704f0889"
import script from "./HistoriqueIntegration.vue?vue&type=script&lang=js"
export * from "./HistoriqueIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports